import React from "react";
import PropTypes from "prop-types";
import AdminSubHeader from "../../../layouts/partials/AdminSubheader";
import { selectEvent } from "../../../../redux/preferences/selectors";
import { connect } from "react-redux";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import {
  generateAllCateringInvoices,
  generateCateringInvoice,
  getRegistrations
} from "../../../../services/api/registrations";
import { getCompanies } from "../../../../services/api/companies";
import { ajaxErrorHandler, defaultSuccess } from "../../../../libs/utils";
import { Trans } from "react-i18next";
import axiosInstance from "../../../../services/api";

const fileDownload = require("js-file-download");

class _Invoices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      companies: [],
      company: undefined,
      registrationLoading: false
    };

    this._handleSearch = this._handleSearch.bind(this);
    this._handleSelect = this._handleSelect.bind(this);
    this._downloadInvoice = this._downloadInvoice.bind(this);
    this._generateInvoice = this._generateInvoice.bind(this);
    this._generateAll = this._generateAll.bind(this);
  }

  static propTypes = {
    event: PropTypes.object
  };

  _handleSearch(value) {
    this.setState({ loading: true });

    getCompanies({
      "filter[name]": value
    })
      .then(response => {
        this.setState({
          companies: response.data
        });
      })
      .catch(ajaxErrorHandler)
      .then(response => {
        this.setState({ loading: false });
      });
  }

  _handleSelect(companies) {
    if (companies.length > 0) {
      this.setState({
        registrationLoading: true,
        company: companies[0]
      });
      getRegistrations({
        "filter[event_id]": this.props.event.id,
        "filter[company_id]": companies[0].id
      })
        .then(response => {
          if (response.data.length > 0) {
            this.setState({
              registration: response.data[0]
            });
          }
        })
        .catch(ajaxErrorHandler)
        .then(response => {
          this.setState({ registrationLoading: false });
        });
    }
  }

  _generateAll() {
    generateAllCateringInvoices(this.props.event.id)
      .then(response => {
        defaultSuccess(
          "Invoices are being generated please check back in a couple of minutes."
        );
      })
      .catch(ajaxErrorHandler);
  }

  _generateInvoice() {
    generateCateringInvoice(this.state.registration.id)
      .then(response => {
        defaultSuccess(
          "Invoice is being generated please check back in a couple of minutes."
        );
      })
      .catch(ajaxErrorHandler);
  }

  _downloadInvoice() {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const registrationId = this.state.registration.id;
    axiosInstance({
      method: "get",
      url: `${baseUrl}registrations/${registrationId}/download-catering-invoice`,
      responseType: "blob"
    }).then(response => {
      fileDownload(
        response.data,
        `${this.props.event.name} - ${this.state.company.name} - Catering Invoice.pdf`
      );
    });
  }

  render() {
    const {
      loading,
      companies,
      registration,
      registrationLoading
    } = this.state;
    return [
      <AdminSubHeader title="Invoices" key="subheader" breadcrumbs={[]} />,
      <div className="m-content" key="content">
        <div className="row">
          <div className="col-xl-12">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-line-graph" />
                    </span>
                    <h3 className="m-portlet__head-text">PDF Invoices</h3>
                  </div>
                </div>
                <div className="m-portlet__head-tools">
                  <ul className="m-portlet__nav">
                    <li className="m-portlet__nav-item">
                      <button
                        className="btn btn-success btn-sm m-btn m-btn m-btn--icon"
                        onClick={this._generateAll}
                      >
                        <span>
                          <i className="la la-refresh" />
                          <span>Generate All</span>
                        </span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="m-portlet__body">
                <div className="m--margin-bottom-20">
                  <AsyncTypeahead
                    multiple={false}
                    options={companies}
                    isLoading={loading}
                    placeholder={"Search ..."}
                    minLength={2}
                    labelKey="name"
                    onSearch={this._handleSearch}
                    onChange={this._handleSelect}
                  />
                </div>

                {registrationLoading && (
                  <div
                    className="m-loader m-loader--primary"
                    style={{
                      width: 30,
                      display: "inline-block"
                    }}
                  />
                )}

                {registration && (
                  <div>
                    <button
                      type="button"
                      className="m-portlet__nav-link btn btn-accent m-btn m-btn--icon m--margin-right-10"
                      onClick={this._generateInvoice}
                    >
                      <span>
                        <i className="la la-eye" />
                        <span>
                          <Trans>Generate Invoice</Trans>
                        </span>
                      </span>
                    </button>
                    {registration.cateringInvoiceUpdatedAt && (
                      <button
                        type="button"
                        className="m-portlet__nav-link btn btn-accent m-btn m-btn--icon"
                        onClick={this._downloadInvoice}
                      >
                        <span>
                          <i className="la la-download" />
                          <span>
                            <Trans>Download Invoice</Trans>
                          </span>
                        </span>
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = function(state) {
  return {
    event: selectEvent(state)
  };
};

const Invoices = connect(mapStateToProps, mapDispatchToProps)(_Invoices);

export default Invoices;
